import { InfoLeagueProps } from '../leagues.props';
import { DiamondGlow } from './DiamondGlow';

export const DiamondGlowLeague: InfoLeagueProps = {
  id: `${process.env.REACT_APP_ID_LEAGUE_DIAMOND_GLOW}`,
  icon: '💠',
  name: 'Diamante Glow',
  description: 'El resplandor divino. Solo para los inmortales.',
  active: false,
  color: '#1A1A1A',
  bgColor: '#B9F2FF',
  borderColor: '#B9F2FF',
  path: '/diamond-glow',
  page: DiamondGlow,
};
